import Heading from './Heading';
import './SectionHeading.scss';

/**
 * Home page section heading (matches "Top Cuisines" style).
 *
 * Usage:
 *  <SectionHeading>TOP CUISINES</SectionHeading>
 */
export default function SectionHeading({ children, className = '', level = 3, ...props }) {
  return (
    <Heading level={level} className={`section-heading ${className}`.trim()} {...props}>
      {children}
    </Heading>
  );
}

